import { motion } from "framer-motion";
import { Building2, ShieldCheck, KeyRound, MonitorSmartphone, Receipt, ArrowUpRight } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { Reveal } from "@/components/Reveal";

const ICONS = [Building2, ShieldCheck, KeyRound, MonitorSmartphone, Receipt];
const SPANS = [
  "md:col-span-7",
  "md:col-span-5",
  "md:col-span-5",
  "md:col-span-7",
  "md:col-span-12",
];

export default function Services() {
  const { t } = useSite();
  return (
    <section id="services" className="relative py-24 md:py-36 bg-background">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <Reveal>
            <div className="flex items-center gap-3 mb-4">
              <span className="h-px w-10 bg-ibk" />
              <span className="text-xs font-bold uppercase tracking-[0.3em] text-ibk">{t.services.label}</span>
            </div>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-foreground max-w-2xl leading-[1.05]">
              {t.services.title}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <span className="font-serif text-6xl text-ibk/20 leading-none select-none">05</span>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-5">
          {t.services.items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={i} delay={i * 0.06} className={SPANS[i]}>
                <motion.div
                  whileHover={{ y: -4 }}
                  data-testid={`service-card-${i}`}
                  className="group h-full rounded-md border border-border bg-[hsl(var(--card))] p-8 md:p-10 transition-colors duration-400 hover:border-ibk"
                >
                  <div className="flex items-start justify-between">
                    <span className="grid place-items-center h-12 w-12 rounded-md bg-ibk/10 text-ibk transition-colors duration-400 group-hover:bg-ibk group-hover:text-white">
                      <Icon size={22} />
                    </span>
                    <span className="font-mono text-xs text-muted-foreground">0{i + 1}</span>
                  </div>
                  <h3 className="mt-6 font-serif text-2xl sm:text-3xl text-foreground flex items-center gap-2">
                    {item.t}
                    <ArrowUpRight size={20} className="text-ibk opacity-0 -translate-x-1 transition-all duration-300 group-hover:opacity-100 group-hover:translate-x-0" />
                  </h3>
                  <p className="mt-3 text-muted-foreground leading-relaxed max-w-xl">{item.d}</p>
                </motion.div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
